import Title from './title';
import TitleAnnouncer from './title-announcer';
import { titleReducer } from './title.reducer';
import * as titleActions from './title.actions';

export {
  Title,
  TitleAnnouncer,
  titleReducer,
  titleActions,
}



// WEBPACK FOOTER //
// src/common/title/index.js